import { render, staticRenderFns } from "./ActivityTabTasks.vue?vue&type=template&id=8ead18bc&"
import script from "./ActivityTabTasks.vue?vue&type=script&lang=js&"
export * from "./ActivityTabTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports